// ============= List of APIs for MindBank =============

export const resetPassword = `${process.env.REACT_APP_MINDBANK_API_GATEWAY}/ResetPassword`;
export const userRegistration = `${process.env.REACT_APP_MINDBANK_API_GATEWAY}/Register`;
export const userLogin = `${process.env.REACT_APP_MINDBANK_API_GATEWAY}/Login`;
export const extendToken = `${process.env.REACT_APP_MINDBANK_API_GATEWAY}/ExtendToken`;
export const handleMedia = `${process.env.REACT_APP_MINDBANK_API_GATEWAY}/media-handle`;

